import { getDataSource } from '@cmg/data-grid';
import { useMemo } from 'react';

import { useGetParticipationSetsLazyQuery } from '../../graphql/__generated__/GetParticipationSets';

const EMPTY_ARRAY = [];

export const useDataSource = () => {
  const [loadRows] = useGetParticipationSetsLazyQuery();

  return useMemo(() => {
    return getDataSource({
      getData: async variables => {
        const response = await loadRows({
          variables: {
            skip: variables.skip,
            take: variables.take,
            where: variables.where,
            order: variables.order,
          },
        });
        return {
          rowData: response?.data?.participationSets?.items ?? EMPTY_ARRAY,
          rowCount: response.data?.participationSets?.totalCount || 0,
        };
      },
    });
  }, [loadRows]);
};
